import styled from 'styled-components';
import { Drawer } from 'antd';

export const VisualActivationWrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
`;

export const HeaderWrapper = styled.div`
  background: #ffffff;
  position: relative;
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  min-height: 64px;
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const TitleText = styled.h1`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatusIndicator = styled.div<{ isConnected?: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => (props.isConnected ? '#10b981' : '#ef4444')};
  animation: ${(props) => (props.isConnected ? 'pulse 2s infinite' : 'none')};

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  gap: 16px;
  padding: 16px;
  min-height: 0;
  overflow: hidden;
`;

export const ScreenViewerPanel = styled.div`
  flex: 0 0 700px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
`;

export const TimelinePanel = styled.div`
  flex: 1;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
  min-width: 400px;
`;

export const PanelHeader = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
`;

export const PanelTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PanelContent = styled.div`
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  backdrop-filter: blur(2px);
`;

export const EmptyState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  text-align: center;
  padding: 40px;
`;

export const EmptyStateIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
`;

export const ClientIdValue = styled.span`
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 4px;
`;

export const StyledDrawer = styled(Drawer)`
  .emp-ant-drawer-header {
    display: none;
  }
  .emp-ant-drawer-body {
    padding: 0;
  }
`;
